<div class="dialog-container" (click)="$event.stopPropagation()">
  <div class="dialog-header">
    <beyond-online-headline
      size="s"
      [headline]="title()"
      class="dialog-title"
    />

    <button class="close-button" (click)="closeDialog()" type="button">
      <beyond-online-icon-close-20 class="close-icon" />
    </button>
  </div>

  <div class="dialog-content">
    <ng-content></ng-content>
  </div>

  <div class="dialog-footer">
    <ng-content select="[footer]"></ng-content>
  </div>
</div>
